import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

export default class AuthenticatedQuestionsYouHaveIndexRoute extends Route {
  @service declare router: RouterService;

  beforeModel() {
    // The section has no landing page of its own — send /questions-you-have to
    // the first item the sidebar lists under it.
    this.router.replaceWith('authenticated.questions-you-have.paying-for-college');
  }
}
